var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuruLandMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465.42 428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.12,256.1C22.12,128.6,123.42,57.1,232.32,57.1s210.2,71.5,197.2,198.9",
    fill: "#67a14a",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m417.72,268.7c0,92.1-83,157.3-185.4,157.3S47.02,360.8,47.02,268.7,130.02,92.6,232.42,92.6s185.3,84,185.3,176.1h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m417.72,268.7c0,92.1-83,157.3-185.4,157.3S47.02,360.8,47.02,268.7,130.02,92.6,232.42,92.6s185.3,84,185.3,176.1h0Z",
    fill: "none",
    stroke: "#010500",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m35.12,256.1C22.12,128.6,123.42,57.1,232.32,57.1s210.2,71.5,197.2,198.9",
    fill: "none",
    stroke: "#010500",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m232.32,72.6c-126.3,2.6-170.2,97.8-176,116.2-6,19.1-17.7,73.8,78.1-5.6,0,0-30.9,89.2,70.8,9,0,0-1.2,28.2,27.1,28.2s27.1-28.2,27.1-28.2c101.7,80.2,70.8-9,70.8-9,95.8,79.5,84.1,24.7,78.1,5.6-5.8-18.4-49.7-113.6-176-116.2Z",
    fill: "#ddf2bf",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m232.32,72.6c-126.3,2.6-170.2,97.8-176,116.2-6,19.1-17.7,73.8,78.1-5.6,0,0-30.9,89.2,70.8,9,0,0-1.2,28.2,27.1,28.2s27.1-28.2,27.1-28.2c101.7,80.2,70.8-9,70.8-9,95.8,79.5,84.1,24.7,78.1,5.6-5.8-18.4-49.7-113.6-176-116.2Z",
    fill: "none",
    stroke: "#010500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 328.02,
    cy: 327,
    r: 27,
    fill: "#ddf2bf",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.62,
    cy: 327,
    r: 27,
    fill: "#ddf2bf",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32,356.1c14.8.5,29.5-.8,44-3.9,2.3-.5,3.9-2.9,3.7-5.6-3.9-43.5-7.8-87-11.7-130.4-.2-2.7-2.2-4.8-4.6-4.9-14.8-.5-29.5.8-44,3.9-2.3.5-3.9,2.9-3.7,5.6,3.9,43.5,7.8,87,11.6,130.4.3,2.7,2.3,4.8,4.7,4.9Z",
    fill: "#67a14a",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32,356.1c14.8.5,29.5-.8,44-3.9,2.3-.5,3.9-2.9,3.7-5.6-3.9-43.5-7.8-87-11.7-130.4-.2-2.7-2.2-4.8-4.6-4.9-14.8-.5-29.5.8-44,3.9-2.3.5-3.9,2.9-3.7,5.6,3.9,43.5,7.8,87,11.6,130.4.3,2.7,2.3,4.8,4.7,4.9Z",
    fill: "none",
    stroke: "#010500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m446.42,356.1c-14.8.5-29.5-.8-44-3.9-2.3-.5-3.9-2.9-3.6-5.6,3.9-43.5,7.8-87,11.6-130.4.2-2.7,2.2-4.8,4.6-4.9,14.8-.5,29.5.8,44,3.9,2.3.5,3.9,2.9,3.6,5.6-3.9,43.5-7.8,87-11.6,130.4-.2,2.7-2.2,4.8-4.6,4.9Z",
    fill: "#67a14a",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m446.42,356.1c-14.8.5-29.5-.8-44-3.9-2.3-.5-3.9-2.9-3.6-5.6,3.9-43.5,7.8-87,11.6-130.4.2-2.7,2.2-4.8,4.6-4.9,14.8-.5,29.5.8,44,3.9,2.3.5,3.9,2.9,3.6,5.6-3.9,43.5-7.8,87-11.6,130.4-.2,2.7-2.2,4.8-4.6,4.9Z",
    fill: "none",
    stroke: "#010500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m339.32,291.8c-7.3-34.8-50.3-34.8-57.5,0",
    fill: "none",
    stroke: "#010500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m182.92,291.8c-7.3-34.8-50.3-34.8-57.5,0",
    fill: "none",
    stroke: "#010500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m283.42,320.8c-22.7,38.4-78.3,38.4-101.1,0",
    fill: "none",
    stroke: "#010500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m265.72,8.3c-8.2,8.2-8.2,21.5-8.2,48.1v8.3c0,26.6,0,39.8,8.2,48.1,4.4,4.4,10.1,6.4,18.5,7.4,1.3,2.7,3.1,5.8,5.3,9.6l.7,1.2c6.4,11.1,9.5,16.6,14.3,16.6s7.9-5.5,14.3-16.6l.7-1.2c1.9-3.4,3.6-6.2,4.9-8.7h84.9c26.5,0,39.7,0,47.9-8.2s8.2-21.5,8.2-48.1v-8.3c0-26.6,0-39.8-8.2-48.1-8.2-8.4-21.4-8.4-47.9-8.4h-95.8c-26.4,0-39.6,0-47.8,8.3h0Z",
    fill: "#438038",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "m308.52,55.4v8.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "m364.42,55.4v8.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "m420.32,55.4v8.3",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuruLandMain);
export default __webpack_public_path__ + "static/media/shuru_land_main.c89d3d5b48450f5d72db011bcc73c1cb.svg";
export { ForwardRef as ReactComponent };